import API from '@services/API';

const RacaService = {
	listar: async (processo) => await API.list(`racas`),
}

export default RacaService;